/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  getCancellationPolicyFormat,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';

function TermsAndConditionsForHotelRoom({ tAndC }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  return (
    <div style={{ border: '1px solid #374471', padding: '10px' }}>
      {tAndC &&
        tAndC.formattedpolicies &&
        getCancellationPolicyFormat(tAndC.formattedpolicies)}
    </div>
  );
}

TermsAndConditionsForHotelRoom.propTypes = {
  tAndC: PropTypes.any.isRequired,
};

export default TermsAndConditionsForHotelRoom;
